import { Injectable } from '@angular/core';
import { VbSnackbarService } from '@viewbid/ui';
import { IProduct } from '@/types/product-type';
import { TranslateService } from '@ngx-translate/core';

const state = {
    cart_products: JSON.parse(localStorage['cart_products'] || '[]'),
};

@Injectable({
    providedIn: 'root',
})
export class CartService {
    public orderQuantity = 1;
    public isCartOpen = false;
    constructor(
        private snackbarService: VbSnackbarService,
        private translate: TranslateService,
    ) {}

    public getCartProducts(): IProduct[] {
        return state.cart_products;
    }

    handleOpenCartSidebar() {
        this.isCartOpen = !this.isCartOpen;
    }

    // add_cart_product
    addCartProduct(payload: IProduct) {
        const isExist = state.cart_products.some(
            (i: IProduct) => i.id === payload.id,
        );
        if (payload.status === 'out-of-stock' || payload.quantity === 0) {
            this.snackbarService.error(
                this.translate.instant('Cart.outOfStock', {
                    title: payload.title,
                }),
            );
        } else if (!isExist) {
            const newItem = {
                ...payload,
                orderQuantity: 1,
            };
            state.cart_products.push(newItem);
            this.snackbarService.success(
                this.translate.instant('Cart.addedToCart', {
                    title: payload.title,
                }),
            );
        } else {
            state.cart_products.map((item: IProduct) => {
                if (item.id === payload.id) {
                    if (typeof item.orderQuantity !== 'undefined') {
                        if (
                            item.quantity >=
                            item.orderQuantity + this.orderQuantity
                        ) {
                            item.orderQuantity =
                                this.orderQuantity !== 1
                                    ? this.orderQuantity + item.orderQuantity
                                    : item.orderQuantity + 1;
                            this.snackbarService.success(
                                this.translate.instant(
                                    'Cart.addedQuantityToCart',
                                    {
                                        quantity: this.orderQuantity,
                                        title: item.title,
                                    },
                                ),
                            );
                        } else {
                            this.snackbarService.success(
                                this.translate.instant(
                                    'Cart.noMoreQuantityAvailable',
                                ),
                            );
                            this.orderQuantity = 1;
                        }
                    }
                }
                return { ...item };
            });
        }
        localStorage.setItem(
            'cart_products',
            JSON.stringify(state.cart_products),
        );
    }

    // total price quantity
    public totalPriceQuantity() {
        return state.cart_products.reduce(
            (
                cartTotal: { total: number; quantity: number },
                cartItem: IProduct,
            ) => {
                const { price, orderQuantity, discount } = cartItem;
                if (typeof orderQuantity !== 'undefined') {
                    if (discount && discount > 0) {
                        // Calculate the item total with discount
                        const itemTotal =
                            (price - (price * discount) / 100) * orderQuantity;
                        cartTotal.total += itemTotal;
                    } else {
                        // Calculate the item total without discount
                        const itemTotal = price * orderQuantity;
                        cartTotal.total += itemTotal;
                    }
                    cartTotal.quantity += orderQuantity;
                }
                return cartTotal;
            },
            {
                total: 0,
                quantity: 0,
            },
        );
    }

    // quantity increment
    increment() {
        return (this.orderQuantity = this.orderQuantity + 1);
    }

    // quantity decrement
    decrement() {
        return (this.orderQuantity =
            this.orderQuantity > 1
                ? this.orderQuantity - 1
                : (this.orderQuantity = 1));
    }

    // quantityDecrement
    quantityDecrement(payload: IProduct) {
        state.cart_products.map((item: IProduct) => {
            if (item.id === payload.id) {
                if (typeof item.orderQuantity !== 'undefined') {
                    if (item.orderQuantity > 1) {
                        item.orderQuantity = item.orderQuantity - 1;
                        this.snackbarService.system(
                            this.translate.instant(
                                'Cart.decrementQuantityFor',
                                { title: item.title },
                            ),
                        );
                    }
                }
            }
            return { ...item };
        });
        localStorage.setItem(
            'cart_products',
            JSON.stringify(state.cart_products),
        );
    }

    // remover_cart_products
    removeCartProduct(payload: IProduct) {
        state.cart_products = state.cart_products.filter(
            (p: IProduct) => p.id !== payload.id,
        );
        this.snackbarService.error(
            this.translate.instant('Cart.removedFromCart', {
                title: payload.title,
            }),
        );
        localStorage.setItem(
            'cart_products',
            JSON.stringify(state.cart_products),
        );
    }

    // clear cart
    clear_cart() {
        const confirmMsg = window.confirm(
            'Are you sure deleted your all cart items ?',
        );
        if (confirmMsg) {
            state.cart_products = [];
        }
        localStorage.setItem(
            'cart_products',
            JSON.stringify(state.cart_products),
        );
    }
    // initialOrderQuantity
    initialOrderQuantity() {
        return (this.orderQuantity = 1);
    }
}
